interface CommandOutput {
  content: string;
  type?: 'error' | 'success' | 'info';
}

export const processCommand = (command: string): CommandOutput => {
  const [cmd, ...args] = command.trim().toLowerCase().split(' ');
  
  switch (cmd) {
    case 'help':
      return {
        content: `Available commands:
        
NAVIGATION:
  ls              - List portfolio sections
  cd <section>    - Navigate to section
  pwd             - Show current location
  
PORTFOLIO:
  whoami          - Display user information
  skills          - Show technical skills
  projects        - List all projects
  education       - Display education info
  achievements    - Show CTF rankings
  contact         - Display contact info
  
SYSTEM:
  clear           - Clear terminal
  history         - Show command history
  uptime          - System uptime
  
HACKER TOOLS:
  nmap            - Network scan simulation
  hack            - Initiate hack sequence
  matrix          - Enter the matrix
  sudo <cmd>      - Execute with privileges
  ps aux          - Show running processes
  top             - Display system resources
  
EASTER EGGS:
  cowsay <text>   - Make the cow speak
  fortune         - Get a random quote
  sl              - Steam locomotive`,
        type: 'info'
      };
    
    case 'ls':
      return {
        content: `total 7
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 about
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 skills
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 projects
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 education
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 achievements
drwxr-xr-x 2 mukul mukul 4096 Jun 12 09:24 contact
-rw-r--r-- 1 mukul mukul  256 Jun 12 09:24 README.md`,
        type: 'success'
      };
    
    case 'whoami':
      return {
        content: `User: Mukul Joshi
Role: Cybersecurity Enthusiast & Ethical Hacker
Status: Joint Secretary, ISDF Club at AIT
Specialization: Penetration Testing, IoT Security
Current Rank: Top 1% on TryHackMe
Location: Pune, Maharashtra
Motto: "Hack the planet, secure the future"`,
        type: 'info'
      };
    
    case 'skills':
      return {
        content: `TECHNICAL SKILLS LOADED:
        
Programming Languages:
  Python          ████████████████████ 90%
  JavaScript      ████████████████████ 85%
  C/C++           ████████████████████ 80%
  Bash            ████████████████████ 85%
  SQL             ████████████████████ 75%

Cybersecurity Tools:
  Kali Linux      ████████████████████ 95%
  Burp Suite      ████████████████████ 90%
  Metasploit      ████████████████████ 85%
  Nmap            ████████████████████ 90%
  Wireshark       ████████████████████ 80%
  John the Ripper ████████████████████ 85%

Frameworks:
  Django          ████████████████████ 85%
  React           ████████████████████ 80%
  Github          ████████████████████ 75%`,
        type: 'success'
      };
    
    case 'projects':
      return {
        content: `PROJECT REPOSITORY:

1. Cyberverse HQ
   - Comprehensive cybersecurity learning platform
   - Interactive modules on Linux commands, bug bounty vulnerabilities, and career guidance
   - Immersive 3D cyberpunk-themed interface
   - Status: Live

2. CTF Platform
   - Django-based CTF hosting platform
   - Real-time scoreboards and multiple challenge categories
   - Status: Production Ready

3. CTF Writeups Platform
   - Blog platform for security writeups with rich text editor
   - User authentication and profile management
   - Status: Active Development

4. ISDF Club Website
   - 3D interactive website using Three.js
   - Complex animations and user interactions
   - Status: Live

5. Steganography Tool
   - Tool for hiding and extracting secret messages in images
   - User-friendly encryption and decryption
   - Status: Live

6. Legacy Portfolio
   - Previous portfolio website
   - Archived for reference
   - Status: Archived
   `,
        type: 'info'
      };
    
    case 'education':
      return {
        content: `EDUCATION SYSTEM LOG:
        
Current:
  Institution: Army Institute of Technology (AIT)
  Degree: Bachelor of Engineering - Computer Science
  Duration: Aug 2023 - June 2027 (Expected)
  Location: Pune, Maharashtra
  
Achievements:
  - Joint Secretary, ISDF Club
  - Top 1% ranking on TryHackMe
  - Multiple CTF top rankings
  - IoT Security research experience`,
        type: 'info'
      };
    
    case 'achievements':
      return {
        content: `CTF ACHIEVEMENT RECORDS:
        
🥈 H7CTF (International) - Rank 2/1000+ teams
🥈 DY Patil's Offline CTF - Rank 2/100+ teams  
🏅 Lakshya CTF - Rank 5/200+ teams
🏅 Vishwa CTF Mini - Rank 11/900+ teams
🏅 Technex CTF - Rank 13/250+ teams
🏅 EnigmaCTF - Rank 15/250+ teams

SPECIAL RECOGNITION:
🎯 Top 1% on TryHackMe Platform
🏆 Joint Secretary, ISDF Club at AIT
🔒 IoT Security Specialist Certification`,
        type: 'success'
      };
    
    case 'contact':
      return {
        content: `CONTACT INFORMATION:
        
📧 Email: memukuljoshi@gmail.com
📱 Phone: +91-7078153883
🎓 Institution: Army Institute of Technology
📍 Location: Pune, Maharashtra

SOCIAL NETWORKS:
💼 LinkedIn: linkedin.com/in/mukul-joshi
🐙 GitHub: github.com/mukul-joshi
🐦 Twitter: @mukul_cyber
🎯 TryHackMe: Top 1% Ranking`,
        type: 'info'
      };
    
    case 'nmap':
      return {
        content: `Starting Nmap scan on portfolio network...

Nmap scan report for portfolio.mukul-joshi.dev
Host is up (0.001s latency).

PORT     STATE SERVICE    VERSION
22/tcp   open  ssh        OpenSSH 8.9
80/tcp   open  http       nginx 1.18.0
443/tcp  open  https      nginx 1.18.0
3000/tcp open  react-dev  Node.js

Service detection performed. Please report any incorrect results.
Nmap done: 1 IP address (1 host up) scanned in 2.45 seconds`,
        type: 'success'
      };
    
    case 'hack':
      return {
        content: `Initiating ethical hack sequence...

[████████████████████████████████] 100%

ACCESS GRANTED
Welcome to the mainframe, fellow hacker!

Remember: With great power comes great responsibility.
Always hack ethically and with permission.

System compromised successfully! 🎯`,
        type: 'success'
      };
    
    case 'matrix':
      return {
        content: `Entering the Matrix...

01001000 01100001 01100011 01101011 01100101 01110010
01010100 01101000 01100101 01001101 01100001 01110100
01110010 01101001 01111000 01001000 01100001 01110011
01011001 01101111 01110101 01001110 01100101 01101111

Wake up, Neo... The Matrix has you.
Follow the white rabbit. 🐰

Reality is just another layer of security to bypass.`,
        type: 'info'
      };
    
    case 'ps':
    case 'ps aux':
      return {
        content: `USER       PID %CPU %MEM    VSZ   RSS TTY      STAT START   TIME COMMAND
mukul     1234  15.2  2.1 128456 64832 pts/0   R+   09:24   0:05 python3 security_scan.py
mukul     1235   8.7  4.2 256912 128456 pts/1  S    09:20   0:12 burp-suite
mukul     1236   5.3  1.1  64832  32416 pts/2  S    09:22   0:03 nmap -sS target
mukul     1237  12.1  3.8 192768  96384 pts/3  S    09:18   0:08 wireshark
mukul     1238   6.8  8.4 524288 262144 pts/4  S    09:15   0:15 msfconsole`,
        type: 'success'
      };
    
    case 'top':
      return {
        content: `Tasks: 127 total,   2 running, 125 sleeping,   0 stopped,   0 zombie
%Cpu(s): 25.3 us,  8.2 sy,  0.0 ni, 65.1 id,  1.2 wa,  0.0 hi,  0.2 si
MiB Mem :  16384.0 total,   2048.5 free,   8192.2 used,   6143.3 buff/cache
MiB Swap:   4096.0 total,   4096.0 free,      0.0 used.   7340.8 avail Mem

Skills Loading: Python [████████████████████] 90%
Security Tools: Kali   [████████████████████] 95%
CTF Ranking:    Top1%  [████████████████████] 100%`,
        type: 'success'
      };
    
    case 'clear':
      return { content: '\x1b[2J\x1b[H', type: 'success' };
    
    case 'pwd':
      return { content: '/home/mukul/portfolio', type: 'success' };
    
    case 'uptime':
      return {
        content: `09:24:15 up 2 days, 14:32, 1 user, load average: 0.15, 0.25, 0.18
Portfolio system has been running smoothly!`,
        type: 'info'
      };
    
    case 'cowsay':
      const message = args.join(' ') || 'Hello from Mukul!';
      return {
        content: ` ${'_'.repeat(message.length + 2)}
< ${message} >
 ${'‾'.repeat(message.length + 2)}
        \\   ^__^
         \\  (oo)\\_______
            (__)\\       )\\/\\
                ||----w |
                ||     ||`,
        type: 'info'
      };
    
    case 'fortune':
      const fortunes = [
        "The best way to predict the future is to invent it. - Alan Kay",
        "Security is not a product, but a process. - Bruce Schneier",
        "The only truly secure system is one that is powered off. - Gene Spafford",
        "Hackers are breaking the systems for profit. Before, it was about intellectual curiosity. - Kevin Mitnick",
        "Knowledge is power, but sharing knowledge is empowerment."
      ];
      return {
        content: fortunes[Math.floor(Math.random() * fortunes.length)],
        type: 'info'
      };
    
    case 'sl':
      return {
        content: `                 (  ) (@@) ( )  (@)  ()    @@    O     @     O     @
            (@@@)
        (    )
      (@@@@)
   (   )
 ====        ________                ___________
_D _|  |_______/        \\__I_I_____===__|_________|
 |(_)---  |   H\\________/ |   |        =|___ ___|      _________________
 /     |  |   H  |  |     |   |         ||_| |_||     _|                \\_____A
|      |  |   H  |__--------------------| [___] |   =|                        |
| ________|___H__/__|_____/[][]~\\_______|       |   -|                        |
|/ |   |-----------I_____I [][] []  D   |=======|____|________________________|_
__/ =| o |=-~~\\  /~~\\  /~~\\  /~~\\ ____Y___________|__|__________________________|_
 |/-=|___|=    ||    ||    ||    |_____/~\\___/          |_D__D__D_|  |_D__D__D_|
  \\_/      \\O=====O=====O=====O_/      \\_/               \\_/   \\_/    \\_/   \\_/

Choo choo! 🚂 The hacker train has arrived!`,
        type: 'info'
      };
    
    case 'sudo':
      if (args.length === 0) {
        return { content: 'sudo: command not specified', type: 'error' };
      }
      return {
        content: `[sudo] password for mukul: 
Sorry, try again.
[sudo] password for mukul:
Access granted! Running with elevated privileges...
${processCommand(args.join(' ')).content}`,
        type: 'success'
      };
    
    case 'history':
      return {
        content: `Command history:
1  whoami
2  ls
3  skills
4  projects
5  hack
6  matrix
7  nmap
8  help`,
        type: 'info'
      };
    
    case 'cd':
      const section = args[0];
      if (!section) {
        return { content: 'cd: missing operand', type: 'error' };
      }
      const validSections = ['about', 'skills', 'projects', 'education', 'achievements', 'contact'];
      if (validSections.includes(section)) {
        return { content: `Navigated to ${section} section`, type: 'success' };
      }
      return { content: `cd: ${section}: No such file or directory`, type: 'error' };
    
    case 'cat':
      const file = args[0];
      if (!file) {
        return { content: 'cat: missing operand', type: 'error' };
      }
      if (file === 'readme.md') {
        return {
          content: `# Mukul Joshi - Cybersecurity Portfolio

Welcome to my interactive Linux desktop portfolio!

This portfolio showcases my journey as a cybersecurity enthusiast,
ethical hacker, and software developer.

## Features
- Interactive Linux desktop environment
- Terminal with custom commands
- Portfolio applications
- CTF achievements and rankings
- Contact information

Type 'help' for available commands.`,
          type: 'info'
        };
      }
      return { content: `cat: ${file}: No such file or directory`, type: 'error' };
    
    default:
      return {
        content: `Command not found: ${command}
Type 'help' for available commands.`,
        type: 'error'
      };
  }
};
